import { render, staticRenderFns } from "./MyDriversListHistory.vue?vue&type=template&id=3b9afe89&lang=pug&"
import script from "./MyDriversListHistory.vue?vue&type=script&lang=ts&"
export * from "./MyDriversListHistory.vue?vue&type=script&lang=ts&"
import style0 from "./MyDriversListHistory.vue?vue&type=style&index=0&id=3b9afe89&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports